import { isNaN, startsWith, toUpper } from "lodash";

/* eslint-disable import/prefer-default-export */
export const capitalizeFirstLetter = string => toUpper(string.charAt(0)) + string.slice(1);

export function replaceAll(str, find, replace) {
  if (!str) return "";
  return str?.replace(new RegExp(find, "g"), replace);
}

const IRREGULAR_NOUNS = {
  child: "children",
  person: "people",
  tooth: "teeth"
  // Add more as needed
};

export const pluralize = (word, count, pluralForm = null) => {
  if (count === 1) return word;
  if (pluralForm) return pluralForm;
  if (IRREGULAR_NOUNS[word]) return IRREGULAR_NOUNS[word];

  return new Intl.PluralRules("en-US").select(count) === "one" ? word : `${word}s`;
};

export const isExternalLink = url => {
  if (!url) return false;

  // Handle relative URLs (they are always internal)
  if (startsWith(url, "/") && !startsWith(url, "//")) return false;

  // If URL doesn't have protocol, add one for URL parsing
  let urlToCheck = url;
  if (!startsWith(url.toLowerCase(), "http://") &&
      !startsWith(url.toLowerCase(), "https://") &&
      !startsWith(url, "//")) {
    urlToCheck = `https://${urlToCheck}`;
  }

  try {
    const currentHostname = window.location.hostname;
    const urlHostname = new URL(urlToCheck).hostname;

    return currentHostname !== urlHostname;
  } catch (e) {
    console.error("Error parsing URL:", e);
    return false;
  }
};

/**
 * Formats a number with thousands separators
 * @param value The number to format or a string that can be converted to a number
 * @param locale The locale to use for formatting (defaults to en-US)
 * @returns A formatted string with thousands separators
 */
export const formatNumberWithCommas = (value, locale = "en-US") => {
  const num = typeof value === "string" ? parseFloat(value) : value;

  if (isNaN(num)) {
    return "0";
  }

  return new Intl.NumberFormat(locale, {
    maximumFractionDigits: 0
  }).format(num);
};
